export const stSetToken = data => {
  const dataResponse = {
    success: false,
    message: '',
    data: null,
  };
  try {
    dataResponse.data = localStorage.setItem('token', JSON.stringify(data));
    dataResponse.success = true;
  } catch (error) {
    dataResponse.message = error.message;
    dataResponse.data = error;
  }
  return dataResponse;
};

export const stGetToken = () => {
  const dataResponse = {
    success: false,
    message: '',
    data: null,
  };
  try {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
      dataResponse.data = token;
      dataResponse.success = true;
    }
  } catch (error) {
    dataResponse.message = error.message;
    dataResponse.data = error;
  }
  return dataResponse;
};

export const stRemoveToken = () => {
  const dataResponse = {
    success: false,
    message: '',
    data: null,
  };
  try {
    dataResponse.data = localStorage.removeItem('token');
    dataResponse.success = true;
  } catch (error) {
    dataResponse.message = error.message;
    dataResponse.data = error;
  }
  return dataResponse;
};
